/* ============================================================
   Проекты федерации: карточки с иконкой, статусом и метой.
   ============================================================ */
import { useFedStore, useL } from '../store';
import { useFedContent } from '../content';
import { Ic } from '../icons';
import { Rv, PageHead } from '../ui';

export default function FedProjects() {
  const { go, lang } = useFedStore();
  const L = useL();
  const projects = useFedContent((s) => s.projects);

  return (
    <div className="fed-pagewrap max-w-[1320px] mx-auto" style={{ padding: '52px 24px 72px' }}>
      <PageHead eyebrow={L.dirEyebrow} title={L.proj_h1} sub={L.proj_sub} mb={32} />

      <div className="grid gap-[18px]" style={{ gridTemplateColumns: 'repeat(auto-fill,minmax(320px,1fr))' }}>
        {projects.map((p, i) => {
          const active = p.status === 'active';
          return (
            <Rv
              key={p.id || p.title_ru}
              delay={(i % 3) * 0.07}
              onClick={() => go('project', { projectId: p.id })}
              className="fed-hover-lift relative overflow-hidden flex flex-col gap-3.5 rounded-[18px] border border-line cursor-pointer"
              style={{ padding: 26, background: 'linear-gradient(160deg,var(--fed-surface-2),var(--fed-surface))' }}
            >
              <div className="flex items-center justify-between gap-3">
                <div className="flex items-center justify-center rounded-[14px] text-accent-bright" style={{ width: 52, height: 52, background: 'rgba(225,18,23,.09)', border: '1px solid var(--fed-line-accent)' }}>
                  <Ic name={p.ic} size={26} />
                </div>
                <span
                  className="inline-flex items-center gap-1.5 rounded-full font-mono uppercase border border-line"
                  style={{
                    padding: '5px 11px', fontSize: 10, letterSpacing: '.1em',
                    background: active ? 'rgba(67,217,106,.12)' : 'rgba(230,183,60,.12)',
                    color: active ? 'var(--fed-ok)' : 'var(--fed-gold)',
                  }}
                >
                  {active ? L.proj_active : L.proj_soon}
                </span>
              </div>
              <h3 style={{ fontSize: 22 }}>{p['title_' + lang]}</h3>
              <p className="text-fg-muted flex-1" style={{ fontSize: 14, lineHeight: 1.6 }}>{p['d_' + lang]}</p>
              <div className="flex items-center justify-between gap-3 border-t border-dashed border-line" style={{ paddingTop: 13 }}>
                <span className="font-mono uppercase text-gold" style={{ fontSize: 11, letterSpacing: '.1em' }}>{p['meta_' + lang]}</span>
                <span className="font-display font-semibold uppercase text-accent-bright" style={{ fontSize: 12 }}>Подробнее →</span>
              </div>
            </Rv>
          );
        })}
      </div>
    </div>
  );
}
